interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, schema }: SEOHeadProps) {
  const fullTitle = `${title} - 韩国漫画网`;
  const baseUrl = 'https://www.koreanmanhua.com';
  const canonical = canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="韩国漫画网" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </>
  );
}